<ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
    [disabled]="ngxDisabled" [autoClearSearch]="false" [(ngModel)]="period" placeholder="Seleccionar Periodo"
    (select)="changePeriod($event)">

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrado
    </ng-template>

</ngx-select>